import { IUser } from '../../shared/iUser';
import httpClient, { IResponse } from '../httpClient';
import { createHeaders, createRequest } from '../util';
import { ILogoutResponse } from './iApiResponse';

const identityProvider = () => {
    const baseURL = 'https://identity.maccaferri.com';

    const getUserAsync = async (): Promise<IResponse<IUser>> => httpClient.getAsync(createRequest(baseURL, '/IdentityV2/GetUser'), createHeaders());

    const logoutAsync = async (): Promise<IResponse<ILogoutResponse>> => httpClient.getAsync(createRequest(baseURL, '/IdentityV2/Logout'), createHeaders());

    return { getUserAsync, logoutAsync };
};

export default identityProvider();
